/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var FxIdWebFeaturesPlayOtaGameVersion;
(function (FxIdWebFeaturesPlayOtaGameVersion) {
    FxIdWebFeaturesPlayOtaGameVersion["Unspecified"] = "Unspecified";
    FxIdWebFeaturesPlayOtaGameVersion["Development"] = "Development";
    FxIdWebFeaturesPlayOtaGameVersion["Release"] = "Release";
    FxIdWebFeaturesPlayOtaGameVersion["UnknownDefaultOpenApi"] = "11184809";
})(FxIdWebFeaturesPlayOtaGameVersion || (FxIdWebFeaturesPlayOtaGameVersion = {}));
export function instanceOfFxIdWebFeaturesPlayOtaGameVersion(value) {
    for (const key in FxIdWebFeaturesPlayOtaGameVersion) {
        if (Object.prototype.hasOwnProperty.call(FxIdWebFeaturesPlayOtaGameVersion, key)) {
            if (FxIdWebFeaturesPlayOtaGameVersion[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function FxIdWebFeaturesPlayOtaGameVersionFromJSON(json) {
    return FxIdWebFeaturesPlayOtaGameVersionFromJSONTyped(json, false);
}
export function FxIdWebFeaturesPlayOtaGameVersionFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function FxIdWebFeaturesPlayOtaGameVersionToJSON(value) {
    return value;
}
export function FxIdWebFeaturesPlayOtaGameVersionToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=FxIdWebFeaturesPlayOtaGameVersion.js.map